module.exports = __webpack_public_path__ + "img/Santander.6a36e19e.png";